import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import style from "css/mypage.module.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { CloseOutlined } from "@ant-design/icons";

function Pastdetailpop(props) {
  const { t, i18n } = useTranslation();

  const closePop = () => {
    props.close();
  };
  const [scheduleinfo, setscheduleinfo] = useState({});
  const [hotdeskInfo, setHotdeskInfo] = useState({});
  const [dataload, setdataload] = useState(false);
  useEffect(() => {
    if (props.type === "M" && props.SCHEDULE_ID !== "") {
      let config = {
        params: {
          SCHEDULE_ID: props.SCHEDULE_ID,
        },
      };
      axios.get("/schedule/myscheduledetail", config).then((res) => {
        if (res.status === 200) {
          setscheduleinfo(res.data);
          setdataload(true);
        }
      });
    } else if (props.type === "H") {
      console.log("detail hotdesk ", props.hotdeskingDetail);
      setHotdeskInfo(props.hotdeskingDetail);
    }
  }, [props.SCHEDULE_ID, props.type, props.hotdeskingDetail]);

  const handleUpdate = () => {
    props.isOpenRes({
      PROCESS_TYPE: "C",
      SCHEDULE_ID: scheduleinfo.SCHEDULE_ID,
      SCHEDULE_TYPE: scheduleinfo.SCHEDULE_TYPE,
      TITLE: scheduleinfo.TITLE,
      RECORD_YN: scheduleinfo.RECORD_YN,
      START_TIME: getReserveDateTime(new Date(), 0),
      END_TIME: getReserveDateTime(new Date(), 30),
      PARTICIPANT_LIST: scheduleinfo.participantlist,
      ENDPOINT_LIST: scheduleinfo.endpointlist,
      CONTENTS: scheduleinfo.CONTENTS,
      OPEN_YN: scheduleinfo.OPEN_YN,
      MAIL_YN: scheduleinfo.MAIL_YN,
      MEETING_PW: scheduleinfo.MEETING_PW,
      ATTACHMENT_LIST: scheduleinfo.attachmentlist,
    });
    closePop();
  };

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  const datetimeConverter = (value) => {
    if (i18n.language === "en-US") {
      return moment(value).locale("en").format("MMMM D, YYYY (ddd) - hh:mm A");
    } else {
      return moment(value).locale("ko").format("YYYY-MM-DD (dd) - a hh:mm");
    }
  };

  const getLocation = (parent, child) => {
    return parent !== null && parent !== undefined && parent !== ""
      ? `${parent} > ${child}`
      : child;
  };

  return (
    <div className="mypagedetailpopup">
      <Modal
        className={style.detailpopup} //모달 ClassName
        open={props.open}
        onCancel={closePop}
        footer={null}
        width="460px"
        closeIcon={
          <CloseOutlined
            style={{
              color: "#121212",
              border: "1px solid #a4a4a4",
              borderRadius: "5px",
              padding: "5px",
              fontSize: "24px",
              top: "20px !important",
              right: "30px !important",
            }}
          />
        }
        centered
      >
        {props.type === "M" ? (
          <div className={style.detailpop_body}>
            <div className={style.detailpop_header}>
              {t("LABEL.TITLE.PAST_MEETING_DETAILS")}
            </div>
            <div className={style.detailpop_title}>{scheduleinfo.TITLE}</div>
            <div className={style.detailpop_content}>
              <div className={style.detailpop_content_line1}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.MEETING_START")}
                </div>
                <div className={style.detailpop_content_body}>
                  {datetimeConverter(scheduleinfo.START_DATETIME)}
                </div>
              </div>
              <div className={style.detailpop_content_line}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.MEETING_END")}
                </div>
                <div className={style.detailpop_content_body}>
                  {datetimeConverter(scheduleinfo.END_DATETIME)}
                </div>
              </div>
              <div className={style.detailpop_content_line}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.MEETING_HOST")}
                </div>
                <div className={style.detailpop_content_body}>
                  {scheduleinfo.EMAIL}
                </div>
              </div>
              <div className={style.detailpop_content_line3}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.MEETING_PTCP")}
                </div>
                <div className={style.detailpop_content_body2 + " scrollbar"}>
                  {dataload ? (
                    scheduleinfo.PARTILIST.length > 3 ? (
                      scheduleinfo.participantlist.map((data, index) => (
                        <div key={index}>
                          {data.MEMBER_NM} {data.EMAIL}
                        </div>
                      ))
                    ) : (
                      <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                    )
                  ) : (
                    <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                  )}
                </div>
              </div>
              <div className={style.detailpop_content_line3}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.MEETING_ROOM")}
                </div>
                <div className={style.detailpop_content_body2 + " scrollbar"}>
                  {dataload ? (
                    scheduleinfo.ENDPOINTLIST.length > 3 ? (
                      scheduleinfo.endpointlist.map((data, index) => (
                        <div key={index}>{data.ENDPOINT_NM}</div>
                      ))
                    ) : (
                      <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                    )
                  ) : (
                    <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                  )}
                </div>
              </div>

              <div className={style.detailpop_content_line}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.MEETING_CONTENT")}
                </div>
                <div className={style.detailpop_content_body2}>
                  {scheduleinfo.CONTENTS}
                </div>
              </div>
              <div className={style.detailpop_content_line2}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.ATTACHMENT")}
                </div>
                <div className={style.detailpop_content_body}>
                  {t("LABEL.NO_ATTACHMENT")}
                </div>
              </div>
            </div>
            <div>
              <div className={style.detailpop_btnline1}>
                <Button
                  type="primary"
                  style={{
                    height: "45px",
                    width: "198px",
                    fontWeight: "bold",
                  }}
                  onClick={() => handleUpdate()}
                >
                  {t("BTN.RESERVE_AGAIN")}
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className={style.detailpop_body}>
            <div className={style.detailpop_header}>
              {t("LABEL.TITLE.HOTDESKING_DETAILS")}
            </div>
            <div
              className={style.detailpop_content}
              style={{ marginBottom: 0, marginTop: 15 }}
            >
              <div className={style.detailpop_content_line}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.HOTDESK.USER")}
                </div>
                <div className={style.detailpop_content_body}>
                  {hotdeskInfo.MEMBER_NM}
                </div>
              </div>
              <div className={style.detailpop_content_line1}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.HOTDESK.START")}
                </div>
                <div className={style.detailpop_content_body}>
                  {datetimeConverter(hotdeskInfo.START_DATETIME)}
                </div>
              </div>

              <div className={style.detailpop_content_line}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.HOTDESK.END")}
                </div>
                <div className={style.detailpop_content_body}>
                  {datetimeConverter(hotdeskInfo.END_DATETIME)}
                </div>
              </div>

              <div className={style.detailpop_content_line1}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.HOTDESK.LOCATION")}
                </div>
                <div className={style.detailpop_content_body}>
                  {getLocation(
                    hotdeskInfo.LOCATION_DEPARTMENT_TITLE,
                    hotdeskInfo.LOCATION_TITLE
                  )}
                </div>
              </div>
              <div className={style.detailpop_content_line1}>
                <div className={style.detailpop_content_header}>
                  {t("LABEL.HOTDESK.RESOURCE")}
                </div>
                <div className={style.detailpop_content_body}>
                  {hotdeskInfo.RESOURCE_TITLE}
                </div>
              </div>
              {/* <div className={style.detailpop_content_line}>
                                    <div className={style.detailpop_content_header}>
                                        좌석 타입
                                    </div>
                                    <div className={style.detailpop_content_body}>
                                        {datetimeConverter(scheduleinfo.END_DATETIME)}
                                    </div>
                                </div> */}
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default Pastdetailpop;
